import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { blockUser, fetchUserList } from "src/services/user.service";

export const doFetchUserList = createAsyncThunk(
  "user/fetchUserList",
  async (payload: { page: number; limit: number; search?: string }) => {
    try {
      // const response: any = await fetchUserList({
      //   page: payload.page,
      //   limit: payload.limit,
      // });
      const response: any = await fetchUserList(payload);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch user list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doBlockUser = createAsyncThunk(
  "user/blockUser",
  async (id: string) => {
    try {
      const response: any = await blockUser(id);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to block/unblock user";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
